import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getAvatarById } from "src/modules/avatar/duck/selectors";
import { useTranslation } from "react-i18next";
import { Flex, Box, Image, Button } from "@chakra-ui/react";
import getImageSrc from "src/utils/getImageSrc";
import { H3, BodyText2, Subtitle2 } from "src/atoms/typography";
import Modal from "src/components/Modal";
import { playStartSound } from "src/modules/sound-alerts/SoundAlerts";
import * as selectors from "src/modules/sound-alerts/duck/selectors";

export default function LowBatteryDialog({
  deviceName,
  playLowBatterySound,
  isOpen,
  onClose,
  avatarId
}) {
  const avatar = useSelector((state) => getAvatarById(state, avatarId));
  const { t } = useTranslation();
  const imgSrc = getImageSrc("low-battery.svg");
  const soundsEnabled = useSelector(selectors.getEnabled);

  useEffect(() => {
    if (playLowBatterySound && soundsEnabled) playStartSound();
  }, [playLowBatterySound, soundsEnabled]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Box width="280px">
        {deviceName && (
          <Box bg="primary" p="8px">
            <Subtitle2
              color="white"
              textAlign="center"
              overflowX="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
            >
              {deviceName}
              {avatar && ` - ${avatar?.name}`}
            </Subtitle2>
          </Box>
        )}
        <Box mt="24px" mx="24px">
          <Flex flexDirection="column" alignItems="center">
            <Image src={imgSrc} />
            <H3 textAlign="center" mt="16px" mb="8px" color="highEmphasis">
              {t("parentStation.lowBattery.heading")}
            </H3>
            <BodyText2 textAlign="center" mb="24px" color="mediumEmphasis">
              {t("parentStation.lowBattery.text")}
            </BodyText2>
          </Flex>
        </Box>
        <Flex mt="16px" pr="8px" pb="8px" justifyContent="flex-end">
          <Button
            variant="flatPrimary"
            onClick={onClose}
            mx="auto"
            minWidth="80px"
          >
            {t("buttons.ok")}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
}
